import Vue from 'vue';
import complaints from './complaints/complaints.vue';
import store from '../common/js/vuex/store';
import complaintsStore from './complaints/complaints-vuex';
if (!store.hasModule(['complaints'])) {
	store.registerModule('complaints', complaintsStore);
}
Vue.component('complaints', complaints);
